<template>
  <div class="header-logo-container">
    <img align="left" src="../../assets/img/htwk.svg" id="htwk-logo">
  </div>
</template>

<script>
/* eslint-disable standard/computed-property-even-spacing */
export default {
  name: 'HtwkLogoHeader'
}
</script>